import { Outlet, Navigate } from 'react-router-dom'
import { URLS } from '../../resources/constants'
import { useAuthStatus } from '../../resources/hooks/authHook'
import { MonthClosedBetweenDepositAndSalesMismatch } from '../../resources/hooks/MonthClosedBetweenDepositAndSalesMismatchHook'

const MonthCloseDepositSalesPos = () => {
    const monthClosedMismatch = MonthClosedBetweenDepositAndSalesMismatch();

    return(
        monthClosedMismatch ? <Navigate to={URLS.DASHBOARD} /> : <Outlet/>
    )
}

export default MonthCloseDepositSalesPos